import React from 'react';

import classes from './SingleTime.css';

const singleTime = (props) => {
  /* if (props.spacing <3) {
    spacingClasses = classes.SpacingRight20;
  } else if (props.spacing > 3 && props.spacing !== (3 || 7 || 11 || 15)) {
    spacingClasses = classes.SpacingTopRight20;
  } else if (props.spacing === (7 || 11 || 15)) {
    spacingClasses = classes.Margin20
  } */
  return (
    <button 
      className={[classes.SingleTimePick, classes[props.spacing], props.active ? classes.ActiveTime : '', props.isDisabled ? classes.Disabled : ''].join(' ')} 
      onClick={() => props.clicked(props.id)}
      disabled={props.isDisabled}>
      {props.time}
    </button>
  );
}

export default singleTime;



// WEBPACK FOOTER //
// ./src/components/TimePicker/SingleTime/SingleTime.js